module.exports = __webpack_public_path__ + "img/04.900651ce.jpg";